import React from 'react';
import { Container, Heading2, IconButton } from '../style';
import { FiMenu, FiMoon, FiSun } from 'react-icons/fi';

const Navbar = ({ toggleTheme, isDark }) => {
    return (
        <>
            <Container
                height='4em'
                flex
                align='center'
                justify='space-between'
                borderBottom
                style={{
                    position: 'sticky',
                    top: 0,
                }}
            >
                <IconButton>
                    <FiMenu />
                </IconButton>
                <Heading2 dot>alfanme</Heading2>
                <IconButton onClick={toggleTheme}>
                    {isDark ? <FiSun /> : <FiMoon />}
                </IconButton>
            </Container>
        </>
    );
};

export default Navbar;
